import { type ReactNode } from 'react'
import { cn } from '../../../lib/utils'

export interface ScreenProps {
  children?: ReactNode
  className?: string
  backgroundClassName?: string
  backgroundImage?: string
}

export function Screen({
  children,
  className,
  backgroundClassName,
  backgroundImage,
}: ScreenProps) {
  // Default cross-axis alignment (items-stretch) on mobile so the inner
  // flex column fills Screen's height — required for SterlingPage's flex-1
  // to have room to grow. Desktop opts back into items-center.
  return (
    <div
      className={cn(
        'relative flex min-h-[calc(100svh_-_var(--banner-height,0px))] w-full md:h-[calc(100svh_-_var(--banner-height,0px))] md:items-center',
        className,
      )}
    >
      {backgroundImage ? (
        <div className="absolute inset-0 overflow-hidden">
          <img
            src={backgroundImage}
            alt=""
            className="pointer-events-none absolute inset-0 h-full w-full object-cover"
          />
          <div
            className="absolute inset-0 backdrop-blur-[125px]"
            style={{
              backgroundImage:
                'linear-gradient(117deg, rgba(255, 255, 255, 0.72) 0%, rgba(255, 255, 255, 0.18) 100%)',
            }}
          />
        </div>
      ) : (
        <div
          className={cn('absolute inset-0 bg-sidebar', backgroundClassName)}
        />
      )}
      <div className="relative flex w-full min-w-0 flex-1 flex-col md:h-full md:min-h-0">
        {children}
      </div>
    </div>
  )
}
